const PageLoader = () => {
  return (
    <div className="w-full h-[100vh] flex items-center justify-center bg-white">
      <div className="flex flex-col items-center justify-center gap-6">
        <img
          src="/assets/images/coachai.png"
          className="w-[180px] md:w-[220px] object-cover animate-pulse"
        />
        <div className="flex gap-2">
          <span className="h-2 w-2 rounded-full bg-blue animate-bounce" style={{ animationDelay: "0ms" }}></span>
          <span className="h-2 w-2 rounded-full bg-blue animate-bounce" style={{ animationDelay: "120ms" }}></span>
          <span className="h-2 w-2 rounded-full bg-blue animate-bounce" style={{ animationDelay: "240ms" }}></span>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
